import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataSourceRequestState } from '@progress/kendo-data-query';
import { BreakpointService } from '@services/breakpoint.service';
import { PatientService } from '@services/patient.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ClinicReportDetailsViewModel } from '../../../../services/reports.service';

@Component({
  selector: 'app-liabilities-credit-report-details',
  templateUrl: './liabilities-credit-report-details.component.html',
  styleUrls: ['./liabilities-credit-report-details.component.less'],
})
export class LiabilitiesReportDetailsComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  unsub = new Subject<any>();
  @Input() gridState: DataSourceRequestState;
  @Input() details: ClinicReportDetailsViewModel[] = [];

  get mobileBreakpoint$() {
    return this.breakpointService.mobileBreakpoint$;
  }

  constructor(
    private router: Router,
    private patientService: PatientService,
    private breakpointService: BreakpointService
  ) {}

  async ngOnInit() {
    if (!this.details) this.details = [];
    this.loading = false;
  }

  navigateToPatientInvoice(patientId: number, invoiceId: number) {
    this.patientService
      .getPatientById(patientId)
      .pipe(takeUntil(this.unsub))
      .subscribe((patient: any) => {
        this.patientService.patientPanelPatient = patient;
        this.router.navigate([
          '/reports',
          {
            outlets: {
              'action-panel': [
                'patient',
                patientId + '_patientprofiletab',
                'patienttabs',
                'patientaccounttab',
                'invoice',
                invoiceId,
              ],
            },
          },
        ]);
      });
  }

  ngOnDestroy() {
    this.unsub.next();
    this.unsub.complete();
  }
}
